import React from "react";
import { useTranslation } from "react-i18next";
import { WebsiteBuilderRange } from "pages/secure/facility/websiteBuilder/editor/components/range/WebsiteBuilderRange";
import { useEmailBuilderContinuousHistoryGroup } from "../../shell/panel/blockSettings/emailBuilderContinuousHistoryGroup";
import { emailBuilderSettingsAutosaveGestureHandlers } from "../../emailBuilderSettingsTextAutosaveDeferral";

type EmailBuilderSettingsSliderFieldProps = {
  label: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number, historyGroupId?: string | null) => void;
  mixed?: boolean;
  ariaLabel?: string;
};

export function EmailBuilderSettingsSliderField(props: EmailBuilderSettingsSliderFieldProps) {
  const { t } = useTranslation();
  const {
    label,
    min,
    max,
    step = 1,
    value,
    onChange,
    mixed = false,
    ariaLabel,
  } = props;
  const continuousHistory = useEmailBuilderContinuousHistoryGroup();
  const autosaveGestureHandlers = emailBuilderSettingsAutosaveGestureHandlers(continuousHistory);

  return (
    <div className="email-builder-settings-slider-field" role="group" aria-label={ariaLabel ?? label}>
      <div className="email-builder-settings-slider-field__label">{label}</div>
      <WebsiteBuilderRange
        min={min}
        max={max}
        step={step}
        value={value}
        setValue={next => {
          onChange(next, continuousHistory.noteChange());
        }}
        mixed={mixed}
        mixedLabel={mixed ? t("Mixed") : undefined}
        {...autosaveGestureHandlers}
      />
    </div>
  );
}
